import styles from './OrderStoryPage.module.css';
import { Header } from '../../components/Header/Header';
import historyIcon from '../../assets/history_page-icon.svg';
import { OrderCard } from '../../components/OrderCard/OrderCard';
import { useSelector } from 'react-redux';
import { useGetAllOrdersQuery } from '../../store/api/order.api';
import { useGetAllAddingOrdersQuery } from '../../store/api/addingOrder.api';
import { useGetUserByIdQuery } from '../../store/api/user.api';

export const OrderStoryPage = () => {
	const schema = window.sessionStorage.getItem('schema');

	const { id } = useSelector(state => state.user.user);
	const { data: user } = useGetUserByIdQuery(id, { skip: !id });

	const { data: mainOrders } = useGetAllOrdersQuery(
		{ params: { userId: user?.id }, schema },
		{ skip: !user?.id }
	);


	const { data: addingOrders } = useGetAllAddingOrdersQuery(
		{ params: { userId: user?.id }, schema },
		{ skip: !user?.id || schema !== 'steam' }
	);

	// Объединение и сортировка
	const combinedOrders = [
		...(mainOrders?.map(order => ({ ...order, _type: 'main' })) || []),
		...(addingOrders?.map(order => ({ ...order, _type: 'adding' })) || [])
	].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

	return (
		<div className={'main'}>
			<Header />
			<div className={styles.header}>
				<div className={styles.title_block}>
					<img src={historyIcon} alt="catalogIcon" />
					<h2>История заказов</h2>
				</div>
			</div>

			<div className={styles.orders_container}>
				{combinedOrders.map(order => {
					if (order._type === 'main') {
						return (
							<OrderCard
								key={`main-${order.id}`}
								status={order.status}
								id={order.id}
								orderPrice={order.price}
								orderItems={!schema ? order.item_orders : order.items || order.subscriptions}
								schema={schema}
								style={schema === '' ? {} : schema === 'PS_sharing' ? { maxHeight: 370 } : schema === 'xbox' || schema === 'fifa' ? { maxHeight: 340 } : { maxHeight: 400 }}
							/>
						);
					}
					if (order._type === 'adding') {
						return (
							<OrderCard
								key={`adding-${order.id}`}
								transactionId={order.transactionId}
								status={order.status}
								id={order.id}
								login={order.inShop?.login}
								orderPrice={order.amount}
								schema={schema}
								style={{ maxHeight: '390px' }}
							/>
						);
					}
					return null;
				})}
			</div>
		</div>
	);
};
